import { CardVariantsEnum } from './Card.types';

export const defaultCardStyles =
  'hover:wh-shadow-lg wh-cursor-pointer wh-transition-shadow';

export const cardStyles = {
  [CardVariantsEnum['dark-primary']]: {
    main_container:
      'wh-w-[343px] wh-bg-blue-dark wh-rounded-lg wh-px-[10px] wh-pt-2 wh-flex wh-flex-col wh-gap-3 wh-pb-[37px] lg:wh-w-[480px] 2xl:wh-w-[634px]',
    image_container: 'wh-w-full wh-h-[100px] lg:wh-h-[130px] wh-relative ',
    date: 'wh-text-gold-light wh-text-sm wh-uppercase wh-font-bold wh-tracking-[2px] wh-pt-2 lg:wh-px-[25px]',
    image:
      'wh-absolute wh-h-full wh-w-full wh-left-0 wh-top-0 wh-block wh-object-cover wh-rounded-t-[8px]',
    title_container:
      'wh-flex wh-flex-col wh-gap-4 lg:wh-px-[25px] wh-h-[216px] lg:wh-h-[220px]',
    title:
      'wh-text-white wh-text-[26px] lg:wh-text-[30px] wh-leading-[35px] wh-font-regular wh-w-[275px] lg:wh-w-full wh-line-clamp-3 lg:wh-line-clamp-3 wh-mt-[5px]',
    description:
      'wh-text-white wh-text-sm lg:wh-text-[18px] wh-line-clamp-3  wh-tracking-[.7px] wh-w-[306px] lg:wh-w-full',
    read_more:
      'wh-text-gold-light wh-tracking-[.7px] wh-font-medium wh-flex wh-items-center wh-gap-[10px] lg:wh-px-[25px]',
    arrow_styles:
      'wh-text-[20px] wh-icon wh-icon-arrow-line-right wh-text-gold-light',
  },
  [CardVariantsEnum['dark-secondary']]: {
    main_container:
      'wh-w-[343px] lg:wh-w-[428px] wh-bg-blue-medium wh-rounded-lg wh-p-4 lg:wh-pt-3 lg:wh-px-1 lg:wh-pb-[34px] wh-flex wh-flex-col wh-justify-between wh-gap-3 wh-h-[349px] lg:wh-h-[400px]',
    image_container: 'wh-w-full wh-h-[90px] lg:wh-h-[140px] wh-relative',
    image:
      'wh-absolute wh-h-full wh-w-full wh-left-0 wh-top-0 wh-block wh-object-cover wh-rounded-t-[8px]',
    title_container: 'wh-flex wh-flex-col wh-gap-4 wh-pt-1',
    title:
      'wh-text-white wh-text-[26px] lg:wh-text-[30px] wh-leading-[35px] wh-font-regular wh-w-[310px] sm:wh-w-[310px] lg:wh-w-full wh-line-clamp-3 lg:wh-pt-1',
    read_more:
      'wh-text-white wh-tracking-[.7px] wh-font-medium wh-flex wh-items-center wh-gap-[10px]',
    arrow_styles:
      'wh-text-[20px] wh-icon wh-icon-arrow-line-right wh-text-white',
  },

  [CardVariantsEnum.white]: {
    main_container:
      'wh-w-[345px] wh-min-h-[188px] lg:wh-h-[266px] wh-bg-white wh-shadow-md wh-rounded-lg wh-p-4 lg:wh-p-5 wh-flex wh-flex-col wh-gap-3 lg:wh-gap-1 lg:wh-w-[408px] wh-flex wh-flex-col wh-justify-between',
    title_container: 'wh-flex wh-flex-col wh-gap-2',
    title:
      'wh-text-[20px] wh-text-grey wh-leading-[28px] wh-font-bold wh-w-full md:wh-w-[311px] wh-line-clamp-2 lg:wh-max-w-[299px] ',
    date: 'wh-text-gold wh-text-sm wh-uppercase wh-font-bold wh-tracking-[1.4px] wh-line-clamp-1 wh-w-[311px] lg:wh-max-w-[299px]',
    read_more:
      'wh-text-gold-light wh-tracking-[.7px] wh-font-medium wh-flex wh-items-center wh-gap-[10px] wh-h-full',
    description:
      'wh-text-grey wh-text-sm  wh-line-clamp-3 wh-line-clamp-3 wh-tracking-[.7px] md:wh-w-[306px] lg:wh-max-w-[299px]',
    arrow_styles:
      'wh-text-[20px] wh-icon wh-icon-arrow-line-right wh-text-gold-light',
  },
};
